import { Helmet } from "react-helmet-async";
import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import StickyPhone from "@/components/StickyPhone";

// Below-the-fold: split out to shrink the initial JS payload.
const TrustedPartners = lazy(() => import("@/components/TrustedPartners"));
const MapSection = lazy(() => import("@/components/MapSection"));
const Contact = lazy(() => import("@/components/Contact"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Hill Brothers | NH Painting &amp; Contracting</title>
        <meta name="description" content="Hill Brothers Painting &amp; Contracting offers professional commercial and residential painting in New Hampshire. Call 603 424 4608 for a free estimate." />
        <meta property="og:title" content="Hill Brothers | NH Painting &amp; Contracting" />
        <meta property="og:description" content="Professional painting services for homes and businesses in New Hampshire. Fully insured. Call 603 424 4608." />
        <meta property="og:url" content="https://hillbrothersnh.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Hill Brothers | NH Painting &amp; Contracting" />
        <meta name="twitter:description" content="Professional painting for homes and businesses in New Hampshire." />
        <link rel="canonical" href="https://hillbrothersnh.com/" />
      </Helmet>

      <Header />

      <main>
        <Hero />
        <About />
        <Services />
        <Suspense fallback={null}>
          <TrustedPartners />
          <MapSection />
          <Contact />
        </Suspense>
      </main>

      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <StickyPhone />
    </div>
  );
};

export default Index;
